import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdAddCircleOutline, MdCheckCircle } from 'react-icons/md';
import { useCurrency } from '../../../hooks/useCurrency';
import { getTranslatedData } from '../../../localization';

const OrderProduct = ({ product, selectable, selected, onSelect, paid }) => {
  const { currencySymbol } = useCurrency();
  const { t } = useTranslation();

  if (!product) {
    return null;
  }

  const renderVariationItems = (variations) => {
    const itemNames = [];

    variations.forEach((variation) => {
      if (variation.items && variation.items.length > 0) {
        variation.items.forEach((item) => {
          itemNames.push(getTranslatedData(item.name));
        });
      } else {
        itemNames.push(getTranslatedData(variation.name));
      }
    });

    if (itemNames.length === 0) {
      return null;
    }

    return <p className="font-primaryMedium text-xs text-bland mt-1">{itemNames.join(', ')}</p>;
  };

  return (
    <div className="py-2 border-b border-border">
      <div className="flex flex-row">
        <p className="font-primaryMedium text-primary text-base w-6 mr-2">{product.quantity}</p>
        <div className="flex flex-1 flex-col w-full">
          <p className="font-primaryMedium text-primary text-base">
            {getTranslatedData(product.name)}
          </p>
          {renderVariationItems(product.variations)}
        </div>
        <div>
          <p className="font-primaryMedium text-primary text-sm ml-5 whitespace-nowrap">
            {(product.total || 0).toFixed(2)} {currencySymbol}
          </p>
          {selectable && (
            <p className="font-primaryMedium text-sm text-right text-success">
              {paid ? t('order.productPaid') : null}
            </p>
          )}
        </div>
        {selectable && (
          <div className="ml-4 w-5">
            {!paid && (
              <button type="button" onClick={() => onSelect(!selected)}>
                {selected ? (
                  <MdCheckCircle className="text-primary text-xl" />
                ) : (
                  <MdAddCircleOutline className="text-primary text-xl" />
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderProduct;
